import ServiceBase from "./apiServiceBase";

const { REACT_APP_ALERT_NOTIFICATION_URL } = process.env;

class AlertsNotificationsApiService extends ServiceBase {
  async getUser(userName) {
    const response = await this.get(`${REACT_APP_ALERT_NOTIFICATION_URL}/user/${userName}`);

    return response;
  }
}

export default new AlertsNotificationsApiService();
